import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * Redirecciones de las rutas viejas de Trade Intelligence.
 *
 * Las cinco secciones vivían en `/importaciones?tab=…` y ahora cada una tiene su
 * URL. Hay enlaces guardados y órdenes compartidas por mail apuntando a las
 * viejas, así que se traducen en vez de romperse.
 *
 * Las redirecciones son `replace`: la URL vieja no queda en el historial, así el
 * botón "atrás" no te devuelve a una ruta que ya no existe.
 */

/** Adónde va cada `?tab=` de la ruta vieja. */
const TAB_TO_PATH: Record<string, string> = {
  orders: '/trade/embarques',
  quotes: '/trade/cotizaciones',
  availability: '/trade/contenedores',
  calculator: '/trade/aduana',
  dashboard: '/trade/indicadores',
};

/** `/importaciones?tab=quotes` → `/trade/cotizaciones` */
export function LegacyImportRedirect() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  return <Navigate to={(tab && TAB_TO_PATH[tab]) ?? '/trade/embarques'} replace />;
}

/**
 * `/pricer-datec/approvals` → `/approvals`. F0 retiró la bandeja del Pricer: la
 * general ya distingue reaperturas, cuenta lo que le toca a cada uno y respeta la
 * visibilidad (vault 264 §3.5).
 */
export function BandejaDatecRedirect() {
  return <Navigate to="/approvals" replace />;
}

/** `/importaciones/:id` → `/trade/embarques/:id`, sin perder cuál era. */
export function LegacyOrderRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `/trade/embarques/${id}` : '/trade/embarques'} replace />;
}

/** `/importaciones/:orderId/contenedores/:containerId` → su equivalente nuevo. */
export function LegacyContainerRedirect() {
  const { orderId, containerId } = useParams<{ orderId: string; containerId: string }>();
  return (
    <Navigate
      to={
        orderId && containerId
          ? `/trade/embarques/${orderId}/contenedores/${containerId}`
          : '/trade/embarques'
      }
      replace
    />
  );
}
